module.exports = __webpack_public_path__ + "static/media/24.c888b7da.jpg";